import './AboutUs.scss';
import { Button } from 'reactstrap';
import { Link } from 'react-router-dom'
import { useEffect } from 'react';


const AboutUs = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div className="about-us-page">
            {/* Top Image Section */}
            <div className="top-about-image"></div>

            {/* Hero Section */}
            <section className="about-hero">
                <div className="container">
                    <div className="about-hero-content">
                        <h1 className="about-hero-title">
                            About <span className="accent-text">Reachtix</span>
                        </h1>
                        <p className="about-hero-subtitle">
                            Pioneering Digital Transformation Through Innovative Solutions
                        </p>
                        <div className="about-hero-text">
                            <p>
                                At Reachtix, we believe in the power of technology to transform businesses
                                and create meaningful impact. Founded with a vision to bridge the gap between
                                innovative ideas and practical implementation, we've grown into a trusted
                                partner for businesses seeking digital excellence.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Mission & Vision Section */}
            <section className="mission-vision-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="mission-card">
                                <div className="mission-icon">
                                    <i className="fa fa-bullseye"></i>
                                </div>
                                <h3>Our Mission</h3>
                                <p>
                                    To empower businesses with cutting-edge digital solutions that drive growth,
                                    enhance efficiency, and create sustainable competitive advantages in an
                                    ever-evolving technological landscape.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="vision-card">
                                <div className="vision-icon">
                                    <i className="fa fa-eye"></i>
                                </div>
                                <h3>Our Vision</h3>
                                <p>
                                    To be the leading catalyst for digital innovation, recognized globally
                                    for transforming how businesses operate, connect, and thrive in the
                                    digital age.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Values Section */}
            <section className="values-section">
                <div className="container">
                    <h2 className="section-title">Our Core Values</h2>
                    <p className="section-subtitle">
                        The principles that guide everything we do
                    </p>

                    <div className="row">
                        <div className="col-md-6">
                            <div className="value-card">
                                <div className="value-icon">
                                    <i className="fa fa-lightbulb-o"></i>
                                </div>
                                <h4>Innovation</h4>
                                <p>
                                    We constantly push boundaries and explore new possibilities to deliver
                                    solutions that set new standards.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="value-card">
                                <div className="value-icon">
                                    <i className="fa fa-users"></i>
                                </div>
                                <h4>Collaboration</h4>
                                <p>
                                    We believe in the power of teamwork and work closely with our clients
                                    to achieve shared success.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="value-card">
                                <div className="value-icon">
                                    <i className="fa fa-shield"></i>
                                </div>
                                <h4>Integrity</h4>
                                <p>
                                    We maintain the highest ethical standards and build trust through
                                    transparency and honesty.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="value-card">
                                <div className="value-icon">
                                    <i className="fa fa-rocket"></i>
                                </div>
                                <h4>Excellence</h4>
                                <p>
                                    We strive for perfection in everything we do, delivering quality that
                                    exceeds expectations.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="value-card">
                                <div className="value-icon">
                                    <i className="fa fa-heart"></i>
                                </div>
                                <h4>Passion</h4>
                                <p>
                                    Our enthusiasm for technology and problem-solving drives us to deliver
                                    exceptional results.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="value-card">
                                <div className="value-icon">
                                    <i className="fa fa-refresh"></i>
                                </div>
                                <h4>Adaptability</h4>
                                <p>
                                    We embrace change and continuously evolve to meet the dynamic needs
                                    of the digital world.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>



            {/* Stats Section */}
            <section className="stats-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-3">
                            <div className="stat-item">
                                <div className="stat-icon-circle">
                                    <i className="fas fa-bullseye"></i>
                                </div>
                                <p>Performance-Focused Campaigns</p>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="stat-item">
                                <div className="stat-icon-circle">
                                    <i className="fas fa-chart-line"></i>
                                </div>
                                <p>Transparent Pricing & Reporting</p>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="stat-item">
                                <div className="stat-icon-circle">
                                    <i className="fas fa-file-signature"></i>
                                </div>
                                <p>No Long-Term Contracts</p>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="stat-item">
                                <div className="stat-icon-circle">
                                    <i className="fas fa-globe"></i>
                                </div>
                                <p>UK-Based, Global Reach</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="about-cta">
                <div className="container">
                    <div className="about-cta-content">
                        <h2>Ready to Transform Your Business?</h2>
                        <p>
                            Join the growing number of businesses that have experienced digital transformation
                            with Reachtix. Let's build something amazing together.
                        </p>
                        <div className="cta-buttons">
                            <Button tag={Link} to='/contact' color='dark' size='lg' outline>Get In Touch</Button>
                            <Button tag={Link} to='/contact' color='dark' size='lg' outline>View Our Services</Button>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AboutUs;